import React from 'react';
import { Button, Text } from 'components/core';

type Props = {
  label?: string;
  permitted?: boolean;
  status?: string;
  url?: string;
  ariaLabel?: string;
};

const ExtractionStatusAction = ({
  label = 'Unavailable',
  permitted = false,
  status,
  url,
  ariaLabel,
}: Props) => {
  const type = status == 'complete' ? 'success' : 'brand';
  const variant = status == 'not-started' ? 'solid' : 'outline';

  if (!permitted) {
    return (
      <Text className="DEStudyListAction" size="xs" variant="weak">
        {label}
      </Text>
    );
  }

  return (
    <Button
      type={type}
      variant={variant}
      to={url}
      className="DEStudyListAction"
      size="xs"
      aria-label={ariaLabel}
    >
      {label}
    </Button>
  );
};

export default ExtractionStatusAction;
